/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import * as _ from 'underscore';

export class ResponseInfo {
  topicName = '';
  sourceName = '';
  applicationName;
  resultValue = '';
  examIdent = '';
  resultMsg = '';
  accession = '';
  associatedAccession = '';
  dataNodes;
  addendumStatus = '';
  reportStatus = '';
  accessionInSaveEvent = '';
  siteNameInSaveEvent = '';
  failureTypes = [];
  state = '';
  actionType = '';
  jwtToken = '';
  mrn = '';
  domain = '';
  messageId = '';
  dictationFailedAction = '';
  failureType = '';
  userName = '';
  siteName = '';
  currentIndex = '';
  patientName = '';
  moduleName = '';
  errorCode = '';
  isDiscardXML = false;
  queryResult = '';
  studyID = [];
  remoteStudyID = [];
  changeType = '';
  changeDescription = '';
  actionStatus = '';
  modalDialog = false;
  destination = '';
  docScanStatus = '';
  isUVCrashed = false;
  reportingAppPath = '';
  contextController = '';
  closedReason = '';

  toString() {
    const props = [
      'topicName',
      'sourceName',
      'resultValue',
      'examIdent',
      'resultMsg',
      'accession',
      'dataNodes',
      'associatedAccession',
      'addendumStatus',
      'reportStaus',
      'accessionInSaveEvent',
      'siteNameInSaveEvent'
    ];
    props.push(
      'failureTypes',
      'state',
      'actionType',
      'dictationFailedAction',
      'userName',
      'siteName',
      'currentIndex',
      'patientName',
      'moduleName',
      'errorCode',
      'isDiscardXML',
      'docScanStatus',
      'isUVCrashed'
    );
    return JSON.stringify(this, props);
  }
}
